import React, { useEffect } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';

import theme from './theme/theme';
import AuthGate from './auth/AuthGate';
import ToastProvider from './components/ToastProvider';
import { useAuthStore } from './context/stores';

/**
 * Main entry point.
 * Keeps global providers here and delegates app behavior to focused components.
 */
export default function App() {
  const initAuthListener = useAuthStore((s) => s.initAuthListener);

  useEffect(() => {
    const unsubscribe = initAuthListener?.();

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [initAuthListener]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastProvider>
        <AuthGate />
      </ToastProvider>
    </ThemeProvider>
  );
}